import classNames from "classnames"
import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { updateActiveView } from "../single_page_app/actions"

export class SpaSidebarNav extends Component {
  changeView = (viewName, e) => {
    e.preventDefault()
    const nextView = viewName

    window.history.pushState(
      window.history.state,
      nextView,
      nextView.toLowerCase()
    )
    this.props.dispatch(updateActiveView(nextView.toLowerCase()))
  }

  render() {
    return (
      <div className="main-sidebar-column">
        <div className="service-sidebar">
          <nav className="sidebar-nav link-menu">
            <ul>
              {this.props.items.map((navItem, index) => {
                return (
                  <li
                    onClick={this.changeView.bind(null, navItem.key)}
                    key={navItem.key}
                    view={navItem.key}
                    className={classNames({
                      first: index == 0,
                      last: index == this.props.items.length - 1,
                      active: this.props.activeView === navItem.key,
                    })}
                  >
                    <a className="link-menu" href="">
                      {navItem.content}
                    </a>
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeView: state.activeView.activeView,
  }
}

export default connect(mapStateToProps)(SpaSidebarNav)

SpaSidebarNav.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number,
      key: PropTypes.string,
      content: PropTypes.node,
    })
  ),
  activeView: PropTypes.string,
  dispatch: PropTypes.func,
}
